module.exports = __webpack_public_path__ + "img/Civil-War-Reenactment.77412802.jpg";